<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="isOpened"
  [cdkConnectedOverlayPositions]="newPosition"
  (detach)="connectedOverlayDetach()"
  (positionChange)="positionChange($event)"
>
  <div #tooltip
    role="tooltip"
    aria-label="Tooltip"
    class="c__tooltip"
    [ngClass]="tooltipClass"
    [attr.data-position]="position"
  >
    <ng-content />

    <ng-container *ngTemplateOutlet="tooltipTemplate" />
  </div>
</ng-template>
